"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Modal_1 = require("./Modal");
exports.default = Modal_1.Modal;
